import React, { Component } from 'react';
import { makePriceFormat } from '../../js/common';
import { selectDonationType } from '../../type/config-status';

export default class extends Component {
    render() {
        var payButtonText = "";
        var payButtonUrl = "";
        
        switch (Number(this.props.boxStatus)) {
            case 1: payButtonText = "준비 중입니다"; break;
            case 2:
                payButtonText = this.props.payButtonText;
                if (this.props.selectDonationType == selectDonationType.Pledge)
                    payButtonUrl = this.props.payUrl.replace("oneoff", "pledge");
                else
                    payButtonUrl = this.props.payUrl.replace("pledge", "oneoff");
                break;
            case 3: payButtonText = "종료되었습니다"; break;
        }

        return (
            <div className="donation-area active">
                {this.props.donationProgressType !== 0 &&
                    (<div>
                        <div className="percent-box">
                            <p className="percent"><b>{this.props.percent}</b>%</p>
                            {/*<p className="remain">{this.props.remain}일 남음</p>*/}
                        </div>
                        <div className="bar"><div className="bar-inner" style={{ width: this.props.percent + "%" }}></div></div>
                        <ul className="stats-info">
                            <li><p className="label">모인금액</p><p className="value">{this.props.selectDonationType === selectDonationType.Pledge ? "월 " : ""}<b>{makePriceFormat(this.props.payPrice)}</b> 원</p></li>
                            {this.props.donationProgressType === 1 &&
                                (<li><p className="label">후원자</p><p className="value"><b>{makePriceFormat(this.props.memberCount)}</b> 명</p></li>)
                            }
                        </ul>
                    </div>)
                }
                <div className="btn-box">
                    <a href={payButtonUrl} className={"btn-donation " + (this.props.boxStatus != 2 ? "deactivate" : "")}>{payButtonText}</a>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/content/DonationInfo.js